export default __webpack_public_path__ + "static/media/Renuable Energy.0294def5.jpg";